import { isPcPlatform } from '@office-start/device-detection-utility';
import { FileType } from '@office-start/document-types';
import { getFileNativeUriScheme, getFileTypeFromExtension, getTypeFromFileTypeName, } from '@office-start/file-utility';
export function isEmailAttachment(file, isMsa) {
    return file && (isMsa ? !!file.subject : file.source === 'EmailAttachment');
}
export function getFileType(doc, draftEnabled) {
    var _a, _b;
    var filetype = FileType.None;
    if (doc.type === 'Lists') {
        filetype = FileType.List;
    }
    else if (doc.type === 'Project' && doc.sub_type === 'ProjectOperations') {
        filetype = FileType.ProjectOperations;
    }
    else if (doc.extension) {
        filetype = getFileTypeFromExtension(doc.extension);
    }
    else {
        filetype = FileType[doc.type] || FileType.None;
    }
    if (filetype === FileType.None) {
        filetype = getTypeFromFileTypeName(doc.type) || FileType.None;
    }
    // Update Fluid fileType to draft only when Draft flight is enabled
    var draftsFolder = '/Drafts';
    if (draftEnabled &&
        filetype === FileType.Fluid &&
        doc.extension === 'fluid' &&
        (((_a = doc.container_url) === null || _a === void 0 ? void 0 : _a.endsWith(draftsFolder)) ||
            ((_b = doc.mru_url) === null || _b === void 0 ? void 0 : _b.includes(draftsFolder + '/')))) {
        filetype = FileType.Draft;
    }
    return filetype;
}
export function shouldIgnoreFile(file) {
    if ((file.type === 'Image' && isEmailAttachment(file)) ||
        file.extension === 'ics' ||
        file.type === 'spsite' ||
        (file.source === 'LocalFile' &&
            (!isPcPlatform() /* Don't process local files if not on PC */ ||
                !getFileNativeUriScheme(getFileType(file)))) /* If local file and there is no native URI scheme, item is not actionable */) {
        return true;
    }
    return false;
}
//# sourceMappingURL=FileUtilities.js.map